module.exports = __webpack_public_path__ + "ptc_nakagawa_V1.04d8514a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_V1.jpg
// module id = 7jOc
// module chunks = 0